import { InvoiceFormSchema } from 'features/Work/form/invoiceForm.schema';

import { RetrievedInvoice } from '../../../hooks/queries/useRetrievedInvoiceQuery';

export const formatRetrievedInvoice = (
  invoice: RetrievedInvoice,
): Omit<InvoiceFormSchema, 'lastEditedAt'> => {
  const tasks = invoice.tasks.map(({ __typename, ...task }) => task);

  return {
    allowCreditCardPayment: invoice.allowCreditCardPayment,
    allowIbanPayment: invoice.allowIbanPayment,
    clientId: invoice.clientId,
    companyProfileId: invoice.companyProfileId,
    currency: invoice.currency,
    fiscalId: invoice.fiscalId,
    lateFeePercentage: invoice.lateFeePercentage,
    lateMaxDays: invoice.lateMaxDays,
    publicPaymentId: invoice.publicPaymentId,
    settings: {
      displayTradeName: !!invoice.settings.displayTradeName,
      invoiceSettingsId: invoice.settings.invoiceSettingsId,
      issuerEmail: invoice.settings.issuerEmail,
      legalMentions: invoice.settings.legalMentions,
    },
    startAt: invoice.startAt,
    subtitle: invoice.subtitle,
    tasks,
    title: invoice.title,
  };
};
